import { Button, Space, Tooltip, Form, message } from 'antd';
import { ConsoleSqlOutlined, EditOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { PageContext } from '../../../../lib/context';
import UsersView from './users';
import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import queries from '../../../../utils/gql/queries';
import auth from '../../../../lib/services';
import { useHistory } from 'react-router';
import { registerables } from 'chart.js';
import mutations from '../../../../utils/gql/mutations';

interface UserInfo {
  id: number;
  username: string;
  full_name: string;
  role_id: number;
  role_name: string;
}

interface Roles {
  id: number;
  name: string;
}

const UsersController = () => {
  const { refetch } = useQuery(queries.GET_USER, {
    fetchPolicy: 'no-cache',
    onCompleted: data => {
      setUsersData(data.users);
    },
  });
  const { data: data_roles, error: errorRoles } = useQuery(queries.GET_ROLES);
  const [option, setOption] = useState();
  const [usersData, setUsersData] = useState<UserInfo[]>([]);
  const [rolesData, setRolesData] = useState<Roles[]>([]);
  const [active, setActive] = useState<boolean>(true);
  const history = useHistory();
  const [display, setDisplay] = useState<boolean>(true);

  const [getUsers, { data: users_data, loading }] = useLazyQuery(queries.GET_USER, {
    fetchPolicy: 'no-cache',
  });

  const [updateUsers] = useMutation(mutations.UPDATE_USERS, {
    onCompleted(res) {
      message.success('Updated user successfully');
      _updateUsers();
      form.resetFields();
      _closeHandler();
    },
    onError({ graphQLErrors }) {
      console.log(graphQLErrors);
    },
  });

  const _updateUsers = () => {
    getUsers();
  };

  const usersColumns = [
    { title: 'Username', dataIndex: 'username', key: 'username' },
    { title: 'Fullname', dataIndex: 'full_name', key: 'full_name' },
    {
      title: 'Role',
      key: 'name',
      render: (item: any) => {
        return item.role.name;
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: any) => (
        <Space>
          <Tooltip title="Edit User">
            <Button type="link" onClick={_showEditHandler(record)}>
              <EditOutlined />
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  const [show, setShow] = useState<boolean>(false);

  const _showEditHandler = (data: any) => {
    return () => {
      form.setFieldsValue({
        username: data.username,
        full_name: data.full_name,
        role_id: data.role_id,
        id: data.id,
      });
      setDisplay(false);
      _showHandler();
    };
  };

  const _onFinish = (data: any) => {
    if (data.id) {
      updateUsers({
        variables: {
          id: data.id,
          data: {
            username: data.username,
            full_name: data.full_name,
            role_id: data.role_id,
          },
        },
      });
    } else {
      auth
        .register(data)
        .then(async (res: any) => {
          if (res.status === 401) {
            message.error('Username is taken.');
            return;
          }
          message.success('Successful');
          refetch();
        })
        .catch((err: any) => {
          console.log(err, 'error');
        });
    }
  };

  const _showHandler = () => setShow(true);
  const _closeHandler = () => {
    setShow(false);
    setDisplay(true);
    form.resetFields();
  };

  useEffect(() => {
    if (users_data) {
      const items = users_data.users.map((users: UserInfo) => {
        return {
          ...users,
        };
      });
      setUsersData(items);
    }
  }, [users_data]);

  useEffect(() => {
    if (data_roles) {
      const data = [data_roles.data].map(data => {
        return {
          ...data,
        };
      });
      const temp = data_roles.roles.map((roles: Roles) => ({
        label: roles.name,
        value: roles.id,
      }));
      setOption(temp);
    }
  }, [data_roles, errorRoles]);

  const [form] = Form.useForm();

  const _switchHandler = () => {
    setActive(!active);
  };

  const _submitHandler = () => {
    form.submit();
  };

  const values: object = {
    form,
    option,
    display,
    active,
    show,
    usersData,
    usersColumns,
    loading,
    _submitHandler,
    _closeHandler,
    _switchHandler,
    _showHandler,
    _onFinish,
  };

  return (
    <PageContext.Provider value={values}>
      <UsersView />
    </PageContext.Provider>
  );
};

export default UsersController;
